// extracted by mini-css-extract-plugin
export var deleteIcon = "_tx-5";
export var deleteOption = "_tx-3";
export var divider = "_tx-2";
export var downloadIcon = "_tx-4";
export var drawer = "_tx-0";
export var drawerFooter = "_tx-6";
export var drawerOpen = "_tx-1";
export var highlighted = "_tx-7";
export var lighterHighlight = "_tx-8";